// services/atualizarEmpreendimento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
// --------------------- Import Interface ---------------------
import { CaracteristicasEmprendimento } from "../interfaces/CaracteristicasEmprendimento";

export const cadastrarCaracteristicasEmpreendimentoService = async (
  values: Partial<CaracteristicasEmprendimento>
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/caracteristicas-empreendimento`;
    try {
      const response = await axios.post(URL, values, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }
};
